<template>
  <div class="bg-modal z-300 fixed top-0 right-0 bottom-0 left-0" v-if="show" @click.self="closeRight()">
      <div class="trans02 mainRight block m-auto absolute h-full z-300 transform  top-0 right-0" ref="rightBlock">
          <div class="bg-white shadow-modal py-24 px-16 overflow-y-auto overflow-x-hidden h-screen w-280">
              <div class="modal-header">
                  <div class="flex justify-end"><span class="cursor-pointer" @click="closeRight('X')">
                          <iCon class="h-24 w-24 text-black" iconClass="close" type="svg"></iCon>
                      </span></div>
              </div>
              <div class="modal-body">
                  <hr class="my-8" />
                  <div class="px-8 rounded-4 py-16 flex justify-between items-center cursor-pointer hover:bg-grey-f2 " @click="extendMore()" :class="{'bg-grey-f2': extendMoreIcon}">
                      <div class="text-18 font-600">{{$t('__headerFooter.__whatIsNew')}}</div>
                      <div class="rounded-50 origin-center transition duration-300 ease-in-out hover:bg-grey-f2 " :class="{'transform':extendMoreIcon, '-rotate-180': extendMoreIcon  }">
                          <iCon class="h-24 w-24 inline-block" :iconClass="'dropdown'" type="svg"></iCon>
                      </div>
                  </div>
                  <div class="overflow-y-auto" ref="releaseMore" :class="{'mt-24': extendMoreIcon}">
                      <div class="mx-8 text-left" v-for="(item, i) in releaseNoteData" v-bind:key="item">
                          <div :class="{'mt-24': i>0}">
                              <div class="font-600">{{item.version}}</div>
                          </div>
                          <div class="leading-16 whitespace-pre-wrap mt-6" v-html="$xss(item['release_note'])"></div>
                      </div>
                  </div>
                  <!-- 暫無文件先隱藏 -->
                  <!-- <div class="w-full bottom-0" :class="{'absolute': extendMoreIcon}">
                      <hr class="my-8" />
                      <div class="px-8 rounded-4 py-16 flex justify-start cursor-pointer hover:bg-grey-f2 active:bg-grey-f2 " @click="goDocumentation()">
                          <div class="text-18 font-600">{{$t('__documentationPage._documentation')}}</div>
                      </div>
                  </div> -->

                  <div class="w-full bottom-0" :class="{'absolute': extendMoreIcon}">
                      <hr class="my-8" />
                      <div class="px-8 rounded-4 py-16 flex justify-start cursor-pointer hover:bg-grey-f2 active:bg-grey-f2 " @click="goFAQ()">
                          <div class="text-18 font-600">{{$t('__faqRelated.__faq')}}</div>
                      </div>
                      <hr class="my-8" />
                  </div>
              </div>
              <div class="modal-footer">
                  <slot :name="footer" v-if="footer"></slot>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// import Button from '@/components/common/Button.vue';
import { globalFixed } from '@/utils/mixin';
import {  releaseNote } from "@/api/users.js";


export default {
  name: 'RightInfo',
  components: {
    // Button,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    footer: String,
    clickOutSideClose: {
      type: Boolean,
      default: true,
    },
    padding: String,
    
  },
  mixins: [globalFixed],
  data() {
    return {
      isShow: this.show,
      extendMoreIcon: false,
      apiError: '',
      releaseNoteData: []
    };
  },
  async created(){ 
    },
  async mounted(){
    await this.getReleaseNote()
  },
  methods: {
    async getReleaseNote(){
      const sendData = {
        q: 5,
      }
      try{
        const {data } = await releaseNote(sendData);
        this.releaseNoteData = data
        
      } catch(error){
        this.apiError = error.response.status;
      }
    },
    closeRight(word){
      if(this.clickOutSideClose || word){
          this.isShow = false;
      }else{
        this.isShow = true;
      }
      this.extendMoreIcon = false;
      this.$refs.rightBlock.style.width = '0px';
      this.$refs.rightBlock.style.opacity = '0%';
      setTimeout(()=>{
        this.$emit('closeRight', this.isShow);
      },201)
      
    },
    extendMore(){
      this.extendMoreIcon = !this.extendMoreIcon
    },
    goFAQ(){
      this.$router.push({path: '/faq'}).catch(err => err);
      this.closeRight()
    },
    goDocumentation(){
      this.$router.push({path: '/documentation'}).catch(err => err);
      this.closeRight()
    }
  },

  computed: {
    getClass() {
      let result = '';
      result = 'border-gray-1200 ';
      
      return result;
    }
  },
  watch:{
    'show': function (n){
      this.isFixed(n, 'fixed', true);
      this.$nextTick(function () {
        setTimeout(()=>{
          if(n){
            this.$refs.releaseMore.style.maxHeight = '0'
            this.$refs.rightBlock.style.width = '280px';
            this.$refs.rightBlock.style.opacity = '100%';
          }
        },1)
      })
      // this.$root.frozen  = n ; 
      
    },
    'extendMoreIcon': function (n){
      if(n){
        this.$refs.releaseMore.style.maxHeight = `${window.innerHeight-275}px`
      }else{
        this.$refs.releaseMore.style.maxHeight = '0'
      }
    },
  }
};
</script>

<style lang="scss" scoped>

.mainRight{
  width: 0px;
  opacity: 0%;
  
}
.trans02{
  transition: 0.2s ease-in-out;
}

.trans01{
  transition: 0.1s linear;
}

</style>